import {Applicant, Car, Child, Income, Loan, Property} from '@sparbanken-syd/kalpylator'

export const getProperty = (): Property => ({
  id: '',
  type: 'properties',
  primary: false,
  propertyType: 'VILLA'
})

export const getLoan = (): Loan => ({
  amount: 0, id: '',
  interestRate: -1,
  loanType: 'MORTGAGE',
  mortgage: -1,
  type: 'loans'
})

export const getApplicant = (): Applicant => ({
  id: '',
  type: 'applicants',
  cityDweller: false,
  occupationType: 'EMPLOYED',
  name: '',
  retired: false
})

export const getIncome = (): Income => ({
  applicantId: '', monthlyIncome: 0, taxFreeIncome: 0,
  id: '', type: 'incomes'
})

export const getChild = (): Child => ({
  id: '', type: 'children'
})

export const getCar = (): Car => ({
  carType: 'OWN',
  id: '',
  type: 'cars',
  monthlyCost: 0
})
